"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarWaterPumpingOnGridCreationRequest = void 0;
const solarWaterPumpingOnGridConstants_1 = require("../constants/solarWaterPumpingOnGridConstants");
class SolarWaterPumpingOnGridCreationRequest {
    constructor() {
        this.solarWaterPumpingOnGridConstants = new solarWaterPumpingOnGridConstants_1.SolarWaterPumpingOnGridConstants();
    }
}
exports.SolarWaterPumpingOnGridCreationRequest = SolarWaterPumpingOnGridCreationRequest;
